/**
 * Rejestr samouczkow strony 'Jak korzystac'. Kolejnosc = kolejnosc na stronie.
 * Kazdy samouczek to osobny plik (jeden autor = jeden plik, bez konfliktow).
 * Ksztalt danych: KONTRAKT.md w tym katalogu. PDF: npm run samouczki:pdf.
 */
import paragon from './paragon';
import paragonNip from './paragon-nip';
import paragonKupon from './paragon-kupon';
import kuponDodaj from './kupon-dodaj';
import kuponSprawdz from './kupon-sprawdz';
import zmianaPlatnosci from './zmiana-platnosci';
import cenniki from './cenniki';

const INSTRUKCJE = [
  paragon,
  paragonNip,
  paragonKupon,
  kuponDodaj,
  kuponSprawdz,
  zmianaPlatnosci,
  cenniki,
];

export default INSTRUKCJE;
